import opener from 'reactApp/utils/opener';

export const openComplain = () => {
    opener('https://help.mail.ru/cloud_web/files/public/#complain');
};
